import { createContext } from 'react';
export const MediaPlaybackTimeContext = /*#__PURE__*/createContext(0);
export const MediaPlaybackTimeProvider = MediaPlaybackTimeContext.Provider;